var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1582 9.28815C18.598 10.188 19.3178 10.6379 19.5647 11.214C19.7803 11.717 19.7803 12.2865 19.5647 12.7896C19.3178 13.3656 18.598 13.8155 17.1582 14.7154L10.396 18.9418C8.79805 19.9405 7.99907 20.4399 7.33973 20.3868C6.76501 20.3406 6.23818 20.0487 5.8944 19.5858C5.5 19.0548 5.5 18.1126 5.5 16.2282V7.77534C5.5 5.89096 5.5 4.94878 5.8944 4.41775C6.23818 3.95487 6.76501 3.66288 7.33973 3.61667C7.99907 3.56367 8.79805 4.06303 10.396 5.06175L17.1582 9.28815Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconFilled);
export default __webpack_public_path__ + "static/media/play-icon-filled.1ffac48f8f5e7d509451d9da75e7ddb0.svg";
export { ForwardRef as ReactComponent };